import request from '@/router/axios';


export const update = (row) => {
    return request({
        url: '/api/blade-sorder/starorder/judicial',
        method: 'post',
        data: row
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-sorder/starorder/judicial',
        method: 'post',
        data: row
    })
}


export const remove = (id) => {
    return request({
        url: '/api/blade-sorder/starorder/judicial/'+id,
        method: 'get'
    })
}
